import React from 'react';

/*
 * Paginazione a pillole numerate: prima e ultima pagina, la corrente e le due
 * vicine, "…" dove si salta. Condivisa da TabellaLista e TabellaListaServer.
 */
export const SidPagination = ({ pageIndex, pageCount, gotoPage, previousPage, nextPage, canPreviousPage, canNextPage }) => {
	if (!pageCount) return null;

	const pagesToShow = [...new Set([0, pageCount - 1, pageIndex, pageIndex - 1, pageIndex + 1])]
		.filter((p) => p >= 0 && p < pageCount)
		.sort((a, b) => a - b);
	const pages = [];
	let prev = -1;
	pagesToShow.forEach((p) => {
		if (p - prev > 1) pages.push(<span key={`gap-${p}`} className="sid-page-gap">…</span>);
		pages.push(
			<button
				key={p}
				className={`sid-page-btn${p === pageIndex ? ' active' : ''}`}
				onClick={() => gotoPage(p)}
			>
				{p + 1}
			</button>
		);
		prev = p;
	});

	return (
		<div className="sid-pagination">
			<button
				className="sid-page-btn sid-page-btn--nav"
				onClick={() => previousPage()}
				disabled={!canPreviousPage}
				aria-label="Pagina precedente"
			>
				‹
			</button>
			{pages}
			<button
				className="sid-page-btn sid-page-btn--nav"
				onClick={() => nextPage()}
				disabled={!canNextPage}
				aria-label="Pagina successiva"
			>
				›
			</button>
		</div>
	);
};

export default SidPagination;
